import http from './httpClient';

export const WastageThresholdsApi = {
  // Feature always enabled; returning true for compatibility
  async getFeatureEnabled() { return true; },
  async setFeatureEnabled() { return true; },
  
  async initMenuItemThresholds(default_quantity = 5) {
    return http.post('/wastage/thresholds/menu-items/initialize', { default_quantity });
  },
  
  async initRawIngredientThresholds(default_cost = 100) {
    return http.post('/wastage/thresholds/raw-ingredients/initialize', { default_cost });
  },
  
  async listMenuItemThresholds() {
    const r = await http.get('/wastage/thresholds/menu-items');
    return r.data || [];
  },
  
  async listRawIngredientThresholds() {
    const r = await http.get('/wastage/thresholds/raw-ingredients');
    return r.data || [];
  },
  
  async updateMenuItemThreshold(id, payload) {
    const r = await http.put(`/wastage/thresholds/menu-items/${id}`, payload);
    return r.data;
  },
  
  async updateRawIngredientThreshold(id, payload) {
    const r = await http.put(`/wastage/thresholds/raw-ingredients/${id}`, payload);
    return r.data;
  },
  
  async processNotifications() {
    return http.post('/wastage/thresholds/process-notifications');
  }
};

export default WastageThresholdsApi;